import { checkoutContactActionSuccess } from './actionCreators'

const getCheckoutContactActionRequest = (body) => (dispatch) => {
  localStorage.setItem('checkoutContact', JSON.stringify(body))
  dispatch(checkoutContactActionSuccess(body))
}

export default getCheckoutContactActionRequest
